import { render, staticRenderFns } from "./thirdlogin.vue?vue&type=template&id=b5969942&scoped=true"
import script from "./thirdlogin.vue?vue&type=script&lang=js"
export * from "./thirdlogin.vue?vue&type=script&lang=js"
import style0 from "./thirdlogin.vue?vue&type=style&index=0&id=b5969942&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5969942",
  null
  
)

export default component.exports